'use client';

import { LabelWithLinkMasking } from '../../../label';
import { COOKIE_LINK_ID } from './LegalList';

export interface LegalListItemLinkProps {
  id: string;
  href: string;
  title: string;
}

type LegalListItemOnClickHandler = ((e: React.MouseEvent) => void) | undefined;

/**
 * Create onClick handler for legal list item. It's distinguished based on the ID. When the ID is a cookie settings link, it
 * creates a handler that opens the CMP UI. Otherwise it returns undefined.
 *
 * @param id - The ID of the legal list item.
 * @returns The onClick handler.
 */
function createOnClickHandler(id: string): LegalListItemOnClickHandler {
  if (id === COOKIE_LINK_ID) {
    return (e: React.MouseEvent) => {
      e.preventDefault();

      e.stopPropagation();

      window?.UC_UI?.showSecondLayer();
    };
  }

  return;
}

/**
 * Legal list item link (client component)
 *
 * @param props - Props for the legal list item link.
 * @returns A legal list item link component.
 */
export function LegalListItemLink(props: LegalListItemLinkProps) {
  const { id, href, title } = props;
  const onClick = createOnClickHandler(id);

  return <LabelWithLinkMasking href={href} onClick={onClick} title={title} text={title} masked={false} />;
}
